export default [
  {
    path: '/etreasury/:key?',
    name: 'etreasuryPage',
    component: () => import(/*webpackChunkName:'etreasury'*/ '@/views/etreasury/index.vue'),
    meta: {},
  },
];
